module.exports = __webpack_public_path__ + "img/team_2.11ada9f5.jpg";